import { render, staticRenderFns } from "./ImpostosTab.vue?vue&type=template&id=3df24170"
import script from "./ImpostosTab.vue?vue&type=script&lang=js"
export * from "./ImpostosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports